'use client';

import { useTranslations } from 'next-intl';
import BrandGradient from '@/components/shared/BrandGradient';
import Button from '@/components/shared/Button';
import Container from '@/components/shared/Container';

export default function NotFound() {
  const t = useTranslations('errors.404');

  return (
    <div className="relative isolate flex grow flex-col justify-center overflow-hidden pt-52 pb-32 text-center">
      <Container>
        <div className="font-display mx-auto max-w-4xl font-medium text-white uppercase">
          <h1 className="text-display-3xs lg:text-display-sm">{t('title')}</h1>
          <p className="text-display-md lg:text-display-2xl mt-8 text-pretty">
            {t('text')}
          </p>
        </div>

        <p className="mt-15">
          <Button
            href="/"
            appearance="light"
          >
            {t('back-home')}
          </Button>
        </p>
      </Container>

      <BrandGradient />
    </div>
  );
}
